export const DETAILS_SCROLL_LINK = 'artwork-details';
export const ARTISTS_SCROLL_LINK = 'artwork-artist';
export const IMAGE_SCROLL_LINK = 'artwork-image';
export const SCROLL_DURATION = 500;
export const GIFT_BALANCE_LINK = 'gift-balance';
export const GIFT_TERMS_LINK = 'gift-terms';

export enum THIRD_DIMS_ARTWORKS {
  SCULPTURE = 'sculpture',
  MIXED_MEDIA = 'mixed media',
  OTHER = 'other',
}
